import { updatesData } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:w-[320px] flex-shrink-0">
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              飞飞漫画网漫画全集更新动态、新番入驻公告、平台功能升级等最新消息，随时掌握。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="flex items-center gap-1.5 text-xs text-primary-600 font-medium">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                实时同步
              </span>
              <span className="w-1 h-1 rounded-full bg-background-300"></span>
              <span className="text-xs text-foreground-400">共{updatesData.length}条动态</span>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative pl-6 border-l-2 border-background-200 space-y-6 md:space-y-7">
              {updatesData.map((item, idx) => (
                <div key={idx} className="relative group cursor-pointer">
                  <div className="absolute -left-[29px] top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 group-hover:scale-125 transition-transform"></div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                      <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded ${
                        item.tag === '更新' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '新番' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '完结' ? 'bg-secondary-100 text-secondary-700' :
                        item.tag === '公告' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-accent-100 text-accent-700'
                      }`}>{item.tag}</span>
                    </div>
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}